import { Button, Card } from "react-native-paper";
import { View, Text } from "../../../components/shared/Themed";
import {
  Alert,
  ImageBackground,
  StyleSheet,
  TouchableOpacity,
  useWindowDimensions,
} from "react-native";
import { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { TextInputControl } from "../../../components/custom/TextInputControl";
import { ReadOnlyProps } from "../../../utils/templates";
import appColors from "../../../utils/constants/colors";
import { useToast } from "react-native-toast-notifications";
import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";
import { Image } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { loginAdminUser } from "../../../redux/dispatcher/adminDispatcher";

interface Props {
  navigation: any;
}

export const AdminLoginScreen = ({ navigation }: ReadOnlyProps<Props>) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [status, setStatus] = useState<string>("");
  const dispatch = useDispatch<any>();

  const { isAuthenticated, loading } = useSelector((state: any) => state.admin);

  useEffect(() => {
    if (isAuthenticated) {
      navigation.navigate("AdminRoot", {
        screen: "AdminDashboard",
      });
    }
  }, [isAuthenticated]);

  const loginDefaultValues = {
    userEmail: "",
    userPassword: "",
  };

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: loginDefaultValues,
  });
  const toast = useToast();
  const dimensions = useWindowDimensions();

  const { isSmallDevice } = useContext(DeviceOrientationContext);
  const onSubmit = (formData: any) => {
    setLoading(true);
    dispatch(
      loginAdminUser({
        email: formData.userEmail,
        password: formData.userPassword,
        remember_me: false,
      })
    )
      .unwrap()
      .then((data: any) => {
        toast.show("Logged in successfully", {
          type: "success",
        });
        navigation.navigate("AdminDashboard");
      })
      .catch((error: any) => {
        toast.show(error, {
          type: "danger",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <View style={styles.container}>
        <View testID="loginPanel" style={{ flexDirection: "row" }}>
          <View
            testID="loginLeftPanel"
            style={{
              width: dimensions.width / 2,
              backgroundColor: "#ededed",
              display: isSmallDevice ? "none" : "flex",
            }}
          >
            <Image
              source={{ uri: require("../../../assets/AnalyticsLogo.png") }}
              style={{
                width: "100%",
                height: dimensions.height / 2,
                marginTop: dimensions.height / 3.5,
              }}
            />
          </View>
          <View
            testID="loginRightPanel"
            style={[
              {
                width: isSmallDevice ? dimensions.width : dimensions.width / 2,
              },
            ]}
          >
            <ImageBackground
              source={{
                uri: isSmallDevice
                  ? require("../../../assets/AnalyticsLogo.png")
                  : "",
              }}
              style={[styles.bgImage]}
              resizeMode="cover"
            >
              <View
                style={{
                  width: isSmallDevice ? "80%" : "50%",
                  marginTop: dimensions.height / 8,
                  marginLeft: isSmallDevice ? "10%" : "27%",
                  backgroundColor: "transparent",
                }}
              >
                <Image
                  style={styles.tinyLogo}
                  source={require("../../../assets/logo2.svg")}
                />
                <Card testID="loginMultiSteps" mode="elevated">
                  <Card.Content style={[styles.content]}>
                    <View style={[styles.contentLabel]}>
                      <Text style={[styles.boldFont, { fontSize: 20 }]}>
                        Login To Admin
                      </Text>
                    </View>
                    <View style={[styles.px_5]}>
                      <Controller
                        control={control}
                        rules={{
                          validate: {
                            required: async (value) => {
                              if (!value) return "* This is required.";
                            },
                          },
                        }}
                        name="userEmail"
                        render={({ field: { onChange, value } }) => (
                          <TextInputControl
                            title="Email"
                            required={true}
                            width="100%"
                            placeholder="Enter Email"
                            value={value}
                            setChangeText={onChange}
                            blurOnSubmit={false}
                            handleOnSubmitEditing={handleSubmit(onSubmit)}
                          />
                        )}
                      />
                      {errors.userEmail && (
                        <Text style={styles.errorColor}>
                          * This is required.
                        </Text>
                      )}
                      <Controller
                        control={control}
                        rules={{
                          validate: {
                            required: async (value) => {
                              if (!value) return "* This is required.";
                            },
                          },
                        }}
                        name="userPassword"
                        render={({ field: { onChange, value } }) => (
                          <TextInputControl
                            title="Password"
                            required={true}
                            width="100%"
                            placeholder="Enter Password"
                            value={value}
                            setChangeText={onChange}
                            isTextEntrySecure={true}
                            blurOnSubmit={false}
                            handleOnSubmitEditing={handleSubmit(onSubmit)}
                          />
                        )}
                      />
                      {errors.userPassword && (
                        <Text style={styles.errorColor}>
                          * This is required.
                        </Text>
                      )}
                      {status === "FAILED" && (
                        <Text style={[styles.errorColor, { marginTop: "2%" }]}>
                          * Invalid username or password.
                        </Text>
                      )}
                    </View>
                    <View style={[styles.px_5]}>
                      <TouchableOpacity>
                        <Text style={[styles.forgetPasswordLink]}>
                          Forget Password?
                        </Text>
                      </TouchableOpacity>
                      <Button
                        mode="contained"
                        onPress={handleSubmit(onSubmit)}
                        loading={isLoading}
                        color={appColors.multiSteps.background}
                        style={{ marginTop: 15 }}
                        uppercase={false}
                      >
                        Login
                      </Button>
                    </View>
                  </Card.Content>
                </Card>
              </View>
            </ImageBackground>
          </View>
        </View>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  errorColor: {
    color: "red",
  },
  px_5: { paddingLeft: "5%", paddingRight: "5%" },
  forgetPasswordLink: {
    marginTop: "2%",
    fontStyle: "italic",
    color: "#adacac",
    textDecorationLine: "underline",
  },
  boldFont: {
    fontWeight: "bold",
  },
  container: {
    flex: 1,
    flexDirection: "row",
  },
  tinyLogo: {
    width: 250,
    height: 60,
    alignSelf: "center",
    marginBottom: "5%",
  },
  content: {
    padding: 0,
    borderColor: "#eee",
    borderWidth: 1,
    borderStyle: "solid",
  },
  contentLabel: {
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "row",
    paddingTop: "5%",
    paddingBottom: "5%",
  },
  bgImage: {
    flex: 1,
    justifyContent: "center",
  },

  successColor: {
    color: "#037d50",
  },
});
